import { DebtorCustomerDetail } from "pages/report/debtor/DebtorCustomerDetail";
import DebtorManage from "pages/report/debtor/DebtorManage";
import { useState } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import DebtorThemeProvider from "./theme/DebtorThemeProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import { PublicRoute } from "./components/PublicRoute";
import { Layout } from "./layouts/layout";
import { BranchSettingMenu } from "./layouts/layoutbranch";
import { BranchForm } from "./pages/branch/branch-list/BranchForm";
import { BranchManagement } from "./pages/branch/branch-list/BranchManagement";
import { Delivery } from "./pages/branch/delivery";
import { DocumentSetting } from "./pages/branch/document";
import { Emp } from "./pages/branch/emp/Emp";
import { EmpManage } from "./pages/branch/emp/EmpManage";
import { Branchgeneralsetting } from "./pages/branch/general";
import { Kitchen } from "./pages/branch/kitchen/Kitchen";
import { KitchenForm } from "./pages/branch/kitchen/KitchenForm";
import { Notification } from "./pages/branch/notification";
import { Payment } from "./pages/branch/payment/Payment";
import { Pos } from "./pages/branch/pos/Pos";
import { TagDiscount } from "./pages/branch/pos/TagDiscount";
import { Printer } from "./pages/branch/printer";
import { ProductBranchForm } from "./pages/branch/products/ProductBranchForm";
import { ProductBranchManagement } from "./pages/branch/products/ProductBranchManagement";
import { SalesModel } from "./pages/branch/sales-model/SalesModel";
import { TableManagement } from "./pages/branch/table/TableManagement";
import { Workingtime } from "./pages/branch/workingtime";
import { CustomerForm } from "./pages/customers/CustomerForm";
import { CustomerGroupList } from "./pages/customers/CustomerGroupList";
import { CustomerGroup } from "./pages/customers/CustomerGroups";
import { Customer } from "./pages/customers/Customers";
import { DailySalesSummary } from "./pages/DailySalesSummary";
import { DepartmentManagement } from "./pages/employee/department/DepartmentManagement";
import { EmployeeForm } from "./pages/employee/employee-list/EmployeeForm";
import { EmployeeManagement } from "./pages/employee/employee-list/EmployeeManagement";
import { EmployeeRoleManagement } from "./pages/employee/employee-role/EmployeeRoleManagement";
import { EmpManageBusinessRoleForm } from "./pages/employee/employee-role/EmpManageBusinessRoleForm";
import { PositionManagement } from "./pages/employee/position/PositionManagement";
import { Login } from "./pages/login/Login";
import { MarketingPoint } from "./pages/marketing/point/MarketingPoint";
import { NotFound } from "./pages/NotFound";
import { AnnotationForm } from "./pages/product-managements/annotation/AnnotationForm";
import { AnnotationManagement } from "./pages/product-managements/annotation/AnnotationManagement";
import { MainCategoryManagement } from "./pages/product-managements/categories/MainCategoryManagement";
import { SubCategoryManagement } from "./pages/product-managements/categories/SubCategoryManagement";
import { ProductManageForm } from "./pages/product-managements/products/ProductManageForm";
import { ProductManagement } from "./pages/product-managements/products/ProductManagement";
import { ProductSetForm } from "./pages/product-managements/products/ProductSetForm";
import { OptionCreate } from "./pages/product-managements/standard/OptionCreate";
import { OptionEdit } from "./pages/product-managements/standard/OptionEdit";
import { OptionStandard } from "./pages/product-managements/standard/OptionStandard";
import { ReportBillDetail } from "./pages/report/BillDetail";
import { DebtorReport } from "./pages/report/debtor/DebtorReport";
import { ReportBill } from "./pages/report/ReportBill";
import { ReportCategory } from "./pages/report/ReportCategory";
import { ReportMonthlySales } from "./pages/report/ReportMonthlySales";
import { ReportProduct } from "./pages/report/ReportProduct";
import { ReportSales } from "./pages/report/Sales";
import { BusinessSettings } from "./pages/settings/business/BusinessSettings";
import { GeneralNumberSettings } from "./pages/settings/general/GeneralNumberSettings";
import { ProductCountUnit } from "./pages/settings/products/ProductCountUnit";
import { ProductSaleUnit } from "./pages/settings/products/ProductSaleUnit";

function App() {
  const [selectbranchID, setSelectBranchID] = useState(1);
  const getSlug = () => {
    const urlParts = window.location.href.split("/").filter(Boolean);
    return urlParts[2];
  };
  const slug = getSlug();

  return (
    <Routes>
      <Route path="/" element={<NotFound />} />

      <Route
        path="/:businessSlug/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      ></Route>

      <Route
        path="/:businessSlug"
        element={
          <ProtectedRoute>
            <Layout
              setSelectBranchID={setSelectBranchID}
              selectbranchID={selectbranchID}
            />
          </ProtectedRoute>
        }
      >
        <Route path="setting/business" element={<BusinessSettings />} />
        <Route path="setting/product/unit" element={<ProductCountUnit />} />
        <Route path="setting/product/saleunit" element={<ProductSaleUnit />} />
        <Route path="setting/document" element={<GeneralNumberSettings />} />

        <Route path="emp/department" element={<DepartmentManagement />} />
        <Route path="emp/position" element={<PositionManagement />} />
        <Route path="emps" element={<EmployeeManagement />} />
        <Route path="emps/create" element={<EmployeeForm />} />
        <Route path="emps/edit/:empID" element={<EmployeeForm />} />

        <Route path="emp/business" element={<EmployeeRoleManagement />} />
        <Route
          path="emp/business/create"
          element={<EmpManageBusinessRoleForm />}
        />
        <Route
          path="emp/business/edit/:empID"
          element={<EmpManageBusinessRoleForm />}
        />

        <Route path="branchs" element={<BranchManagement />} />
        <Route path="branchs/create" element={<BranchForm />} />
        <Route path="branchs/edit/:branchID" element={<BranchForm />} />

        <Route
          path={`branch`}
          element={
            <Navigate to={`/${slug}/branch/setting/info/${selectbranchID}`} />
          }
        />

        <Route
          path={`branch/setting`}
          element={
            <BranchSettingMenu
              setSelectBranchID={setSelectBranchID}
              selectbranchID={selectbranchID}
            >
              <Outlet />
            </BranchSettingMenu>
          }
        >
          <Route path={`info/:branchID`} element={<BranchForm />} />
          <Route path={`kitchen/:branchID`} element={<Kitchen />} />
          <Route path={"kitchen/:branchID/manage"} element={<KitchenForm />} />
          <Route
            path={"kitchen/:branchID/manage/:kitchenID"}
            element={<KitchenForm />}
          />
          <Route path="general/:branchID" element={<Branchgeneralsetting />} />
          <Route
            path="general/:branchID/workingtime"
            element={<Workingtime />}
          />

          <Route path="salesmodel/:branchID" element={<SalesModel />} />

          <Route path="payment/:branchID" element={<Payment />} />
          <Route path="printer/:branchID" element={<Printer />} />
          <Route path="document/:branchID" element={<DocumentSetting />} />
          <Route path="notification/:branchID" element={<Notification />} />
          <Route path="pos/:branchID" element={<Pos />} />
          <Route path="pos/:branchID/tag-discount" element={<TagDiscount />} />
          <Route path="emp/:branchID" element={<Emp />} />
          <Route path="emp/:branchID/manage" element={<EmpManage />} />
          <Route
            path="emp/:branchID/manage/:permissionID"
            element={<EmpManage />}
          />
          <Route path="table/:branchID" element={<TableManagement />} />
          <Route path="delivery/:branchID" element={<Delivery />} />
          <Route
            path="product/:branchID"
            element={<ProductBranchManagement />}
          />
          <Route
            path="product/:branchID/manage/:productID"
            element={<ProductBranchForm />}
          />
        </Route>
        {/* Marketing */}
        <Route path={`marketing/point`} element={<MarketingPoint />} />
        <Route path="customer" element={<Customer />} />
        <Route path="customer/create" element={<CustomerForm />} />
        <Route path="customer/edit/:customerID" element={<CustomerForm />} />

        <Route path="customer-group" element={<CustomerGroup />} />
        <Route path="customer-group/:id" element={<CustomerGroupList />} />

        <Route path="products" element={<ProductManagement />} />
        <Route path="products/create" element={<ProductManageForm />} />
        <Route path="products/:pset/create" element={<ProductSetForm />} />
        <Route
          path="products/edit/:productID"
          element={<ProductManageForm />}
        />
        <Route
          path="products/:pset/edit/:productID"
          element={<ProductSetForm />}
        />
        <Route path="product/category" element={<MainCategoryManagement />} />
        <Route path="product/subcategory" element={<SubCategoryManagement />} />
        <Route path="product/options/standard" element={<OptionStandard />} />
        <Route
          path="product/options/standard/create"
          element={<OptionCreate />}
        />
        <Route
          path="product/options/standard/edit/:optionID"
          element={<OptionEdit />}
        />
        <Route
          path="product/options/annotation"
          element={<AnnotationManagement />}
        />
        <Route
          path="product/options/annotation/create"
          element={<AnnotationForm />}
        />
        <Route
          path="product/options/annotation/edit/:optionID"
          element={<AnnotationForm />}
        />
        {/* report */}
        <Route path={`report/sales`} element={<ReportSales />} />
        <Route path={`report/monthly/sales`} element={<ReportMonthlySales />} />
        <Route path={`report/product/sales`} element={<ReportProduct />} />
        <Route path={`report/category/sales`} element={<ReportCategory />} />
        <Route path={`report/bill/sales`} element={<ReportBill />} />
        <Route
          path={`report/bill/detail/:billID`}
          element={<ReportBillDetail />}
        />

        <Route path={`report/debtor/list`} element={<DebtorThemeProvider><DebtorReport /></DebtorThemeProvider>} />
        <Route
          path={`report/debtor/customer/:customerID`}
          element={<DebtorThemeProvider><DebtorCustomerDetail /></DebtorThemeProvider>}
        />
        <Route path={`report/debtor/manage/:invoiceId`} element={<DebtorThemeProvider><DebtorManage /></DebtorThemeProvider>} />
      </Route>
      <Route
        path={`/:businessSlug/report/daily-sales-summary/:date`}
        element={<DailySalesSummary />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
